const pad = (value: number): string => String(value).padStart(2, "0");

export const toLocalTime = (value: Date): string =>
  `${pad(value.getHours())}:${pad(value.getMinutes())}`;
